/*
 * @description:
 * @author: Jason Wong
 * @since: 2024-07-11 10:32:24
 */
import AccountLayout from "@/views/layout/AccountLayout";
import config from "@/configs/pathConfigures";
import NudeLayout from "@/views/layout/NudeLayout.vue";

const loginRoute = {
    path: config.prefixUrl + "/account",
    component: AccountLayout,
    redirect: config.prefixUrl + "/account/login",
    children: [
        {
            name: "login",
            path: "login",
            component: () => import("@/views/account/Login"),
            meta: { title: "登录" },
        },
    ],
};

const forgotPasswordRoute = {
    path: config.prefixUrl + "/account",
    component: NudeLayout,
    redirect: config.prefixUrl + "/account/forgot",
    children: [
        {
            name: "forgotPassword",
            path: "forgot",
            component: () => import("@/views/account/forgot"),
            meta: { title: "忘记密码" },
        },
    ],
};

const registerRoute = {
    path: config.prefixUrl + "/account",
    component: AccountLayout,
    redirect: config.prefixUrl + "/account/login",
    children: [
        {
            name: "register",
            path: "register",
            component: () => import("@/views/account/register"),
            meta: { title: "注册" },
        },
    ],
};

const inviteLinkRoute = {
    path: config.prefixUrl + "/invite",
    component: NudeLayout,
    children: [
        {
            name: "userInvite",
            path: "catUser",
            component: () => import("@/views/account/InviteUser"),
        },
        {
            name: "teamMemberInvite",
            path: "catTeam",
            component: () => import("@/views/account/InviteTeamMember.vue"),
        }
    ],
};

const userAgreementRoute = {
    name: "userAgreement",
    path: config.prefixUrl + "/userAgreement",
    component: () => import("@/views/base/userAgreement.vue"),
    meta: { title: "用户协议" },
  };

  const privacyPolicyRoute = {
    name: "privacyPolicy",
    path: config.prefixUrl + "/privacyPolicy",
    component: () => import("@/views/base/privacyPolicy.vue"),
    meta: { title: "用户协议" },
  };

export { loginRoute, registerRoute, forgotPasswordRoute,inviteLinkRoute,userAgreementRoute,privacyPolicyRoute };
